export default "__VITE_PUBLIC_ASSET__ff376090__"